"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInput = void 0;
var react_1 = __importDefault(require("react"));
var FormField_1 = require("../FormField");
var Input_1 = require("../Input");
exports.FormInput = react_1.default.forwardRef(function (props, ref) {
    return react_1.default.createElement(FormField_1.FormField, __assign({ control: Input_1.Input, ref: ref }, props));
});
//# sourceMappingURL=FormInput.js.map